import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI, eventAPI } from '../services/api';

const Header = () => {
  const { user, isAuthenticated, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [showBeBuyerModal, setShowBeBuyerModal] = useState(false);
  const [events, setEvents] = useState([]);
  const [beBuyerForm, setBeBuyerForm] = useState({
    name: '',
    surname: '',
    company_name: '',
    phone: '',
    notes: '',
    event_id: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (showBeBuyerModal) {
      fetchEvents();
      setBeBuyerForm({
        name: user?.name || '',
        surname: '',
        company_name: '',
        phone: user?.phone || '',
        notes: '',
        event_id: ''
      });
    }
  }, [showBeBuyerModal, user]);

  const fetchEvents = async () => {
    try {
      const response = await eventAPI.getAll();
      setEvents(response.data.events);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const handleBeBuyer = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const response = await authAPI.becomeBuyer(beBuyerForm);
      await refreshUser(); // User'ı yeniden yükle
      setShowBeBuyerModal(false);
      alert('Successfully became a buyer!');
      window.location.reload(); // Sayfayı yenile
    } catch (error) {
      setError(error.response?.data?.message || 'Error becoming a buyer');
    } finally {
      setSubmitting(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header style={{
      backgroundColor: '#EDB404',
      color: 'white',
      padding: '10px 0',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        <Link
          to="/"
          style={{
            color: 'white',
            textDecoration: 'none',
            fontSize: 'clamp(16px, 4vw, 20px)',
            fontWeight: 'bold',
            flex: '1 1 auto',
            minWidth: '200px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}
        >
          <img
            src="/uzak-rota-logo.png"
            alt="UzakRota Logo"
            style={{
              height: 'clamp(35px, 6vw, 60px)',
              width: 'auto',
              objectFit: 'contain'
            }}
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </Link>

        <nav style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'clamp(10px, 2vw, 20px)',
          flexWrap: 'wrap'
        }}>
          {isAuthenticated ? (
            <>
              {user?.is_super_admin ? (
                <>
                  <Link
                    to="/admin/super-admin"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    Super Admin Panel
                  </Link>
                </>
              ) : user?.is_admin ? (
                <>
                  <Link
                    to="/"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    Home
                  </Link>
                  <Link
                    to="/my-meetings"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    My Meetings
                  </Link>
                  <Link
                    to="/admin/company-admin"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    Company Admin Panel
                  </Link>
                </>
              ) : user?.buyer ? (
                <>
                  <Link
                    to="/"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    Home
                  </Link>
                  <Link
                    to="/my-meetings"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    My Meetings
                  </Link>
                  <Link
                    to="/buyer/dashboard"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    Buyer Dashboard
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    Home
                  </Link>
                  <Link
                    to="/my-meetings"
                    style={{
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                    }}
                  >
                    My Meetings
                  </Link>
                  <button
                    onClick={() => setShowBeBuyerModal(true)}
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      color: 'white',
                      border: '1px solid white',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: 'clamp(14px, 3vw, 16px)',
                      fontWeight: '500',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'white';
                      e.target.style.color = '#EDB404';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.color = 'white';
                    }}
                  >
                    Become Buyer
                  </button>
                </>
              )}
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'clamp(8px, 2vw, 12px)',
                marginLeft: 'clamp(10px, 2vw, 20px)',
                paddingLeft: 'clamp(10px, 2vw, 20px)',
                borderLeft: '1px solid rgba(255, 255, 255, 0.3)'
              }}>
                <span style={{
                  fontSize: 'clamp(12px, 2.5vw, 14px)',
                  color: 'white'
                }}>
                  Welcome, {user?.name}
                </span>
                <button
                  onClick={handleLogout}
                  style={{
                    backgroundColor: 'transparent',
                    color: 'white',
                    border: '1px solid white',
                    padding: 'clamp(6px, 1.5vw, 8px) clamp(12px, 3vw, 16px)',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: 'clamp(12px, 2.5vw, 14px)',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = 'white';
                    e.target.style.color = '#EDB404';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = 'white';
                  }}
                >
                  Logout
                </button>
              </div>
            </>
          ) : (
            <>
              <Link
                to="/login"
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  fontWeight: '500',
                  padding: '8px 12px',
                  borderRadius: '4px',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                Login
              </Link>
              <Link
                to="/register"
                style={{
                  color: 'white',
                  textDecoration: 'none',
                  fontSize: 'clamp(14px, 3vw, 16px)',
                  fontWeight: '500',
                  padding: '8px 12px',
                  borderRadius: '4px',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                }}
              >
                Register
              </Link>
            </>
          )}
        </nav>
      </div>

      {/* Be Buyer Modal */}
      {showBeBuyerModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2000,
          padding: '20px'
        }} onClick={() => setShowBeBuyerModal(false)}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '30px',
            maxWidth: '500px',
            width: '100%',
            maxHeight: '90vh',
            overflowY: 'auto'
          }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2 style={{ margin: 0, color: '#333' }}>Become a Buyer</h2>
              <button
                onClick={() => setShowBeBuyerModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                ×
              </button>
            </div>

            {error && (
              <div style={{
                backgroundColor: '#fee',
                color: '#c33',
                padding: '10px',
                borderRadius: '4px',
                marginBottom: '15px'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleBeBuyer}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333' }}>Name *</label>
                <input
                  type="text"
                  value={beBuyerForm.name}
                  onChange={(e) => setBeBuyerForm({...beBuyerForm, name: e.target.value})}
                  required
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold',color: '#333' }}>Surname</label>
                <input
                  type="text"
                  value={beBuyerForm.surname}
                  onChange={(e) => setBeBuyerForm({...beBuyerForm, surname: e.target.value})}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold',color: '#333' }}>Event *</label>
                <select
                  value={beBuyerForm.event_id}
                  onChange={(e) => setBeBuyerForm({...beBuyerForm, event_id: e.target.value})}
                  required
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                >
                  <option value="">Select Event</option>
                  {events.map((event) => (
                    <option key={event.id} value={event.id}>{event.name}</option>
                  ))}
                </select>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold',color: '#333' }}>Company Name</label>
                <input
                  type="text"
                  value={beBuyerForm.company_name}
                  onChange={(e) => setBeBuyerForm({...beBuyerForm, company_name: e.target.value})}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold',color: '#333' }}>Phone</label>
                <input
                  type="text"
                  value={beBuyerForm.phone}
                  onChange={(e) => setBeBuyerForm({...beBuyerForm, phone: e.target.value})}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold',color: '#333' }}>Notes</label>
                <textarea
                  value={beBuyerForm.notes}
                  onChange={(e) => setBeBuyerForm({...beBuyerForm, notes: e.target.value})}
                  rows="3"
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                />
              </div>

              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button
                  type="button"
                  onClick={() => setShowBeBuyerModal(false)}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#6c757d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={submitting}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#EDB404',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: submitting ? 'not-allowed' : 'pointer',
                    opacity: submitting ? 0.6 : 1
                  }}
                >
                  {submitting ? 'Submitting...' : 'Become Buyer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
